import AuthService from "../login/auth.service";
import { consultasAPI } from "../../components/generico/utils/UrlAPI";
import axios from "axios";

class PadronService {


  async padrones() {
    var data = JSON.stringify({
      canal: "WEB",

    });

    var config = {
      method: "post",
      url: consultasAPI + "padrones",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
      data: data,
    };
    return await axios(config);
  }
}
export default new PadronService();